import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María Eugenia R. — Buenos Aires',
    quote: 'Jamás pensé que iba a poder hacer una milhojas en mi casa que quedara así. La primera vez que la armé mi marido pensó que la había comprado en una confitería. El merengue quedó perfecto, firme y brillante. Gracias Stella, sos una genia.',
    badge: null,
    initials: 'ME',
    bgColor: 'bg-pink-100',
    textColor: 'text-pink-700',
    image: 'https://cdn.magicpatterns.com/uploads/spruJ9dS5HWCyx2Y7Sw3tW/thumb.png',
    objectPosition: 'object-top'
  }, {
    name: 'Rodrigo M. — Córdoba',
    quote: 'Soy el que cocina en casa y quería sorprender a mi vieja en su cumple. Seguí el método al pie de la letra y quedó espectacular. Mis hermanas me pidieron que la haga para Navidad también. Vale cada peso que pagué.',
    badge: null,
    initials: 'RM',
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-700',
    image: 'https://cdn.magicpatterns.com/uploads/vqCjaArakca7xU1wtDdRzR/thumb.jpg',
    objectPosition: 'object-center'
  }, {
    name: 'Lorena F. — Rosario',
    quote: 'Empecé haciendo la milhojas para mis amigas. Cuando vieron el resultado me empezaron a pedir que les hiciera para sus eventos. Hoy vendo entre 3 y 5 tartas por semana a $50.000 cada una. El método de Stella me cambió la vida, literal.',
    badge: null,
    initials: 'LF',
    bgColor: 'bg-purple-100',
    textColor: 'text-purple-700',
    image: 'https://cdn.magicpatterns.com/uploads/2V8B6PypvcszcjGukXdowU/thumb.png',
    objectPosition: 'object-center'
  }, {
    name: 'Diego A. — Mendoza',
    quote: 'Trabajo en construcción y en mis tiempos libres empecé a hacer pastelería. Con este método aprendí la milhojas y ahora los fines de semana hago pedidos para eventos. El mes pasado facturé más con las milhojas que con mi trabajo principal. Increíble.',
    badge: null,
    initials: 'DA',
    bgColor: 'bg-amber-100',
    textColor: 'text-amber-700',
    image: 'https://cdn.magicpatterns.com/uploads/q1wd5UWoFyCCdb7JZa3ZU5/heylloyd-image-1772550136948.png',
    objectPosition: 'object-center'
  }];
  return <section className="bg-brand-cream-light py-12 md:py-16" data-id="element-349">
      <div className="max-w-6xl mx-auto px-4" data-id="element-350">
        <FadeIn data-id="element-351">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-brown text-center mb-16" data-id="element-352">
            Lo que dicen quienes ya lo hicieron
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-353">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-354">
              <div className="bg-white rounded-2xl shadow-warm border border-brand-gold/10 h-full flex flex-col relative" data-id="element-355">
                {testimonial.badge && <div className="absolute top-3 right-3 bg-brand-gold-dark text-white text-sm font-bold px-4 py-1.5 rounded-full shadow-md z-20" data-id="element-356">
                    {testimonial.badge}
                  </div>}

                {testimonial.image && <div className="w-full h-52 overflow-hidden rounded-t-2xl" data-id="element-357">
                    <img src={testimonial.image} alt={testimonial.name} className={`w-full h-full object-cover ${testimonial.objectPosition}`} data-id="element-358" />
                  </div>}

                <div className="p-8 flex flex-col flex-grow" data-id="element-359">
                  <div className="flex items-center mb-6" data-id="element-360">
                    <div className={`w-14 h-14 ${testimonial.bgColor} rounded-full flex items-center justify-center ${testimonial.textColor} font-bold text-xl mr-4 border-2 border-brand-gold/20 shrink-0`} data-id="element-361">
                      {testimonial.initials}
                    </div>
                    <div data-id="element-362">
                      <h4 className="font-bold text-brand-brown text-lg" data-id="element-363">
                        {testimonial.name}
                      </h4>
                      <div className="text-brand-orange text-sm mt-1" data-id="element-364">
                        ⭐⭐⭐⭐⭐
                      </div>
                    </div>
                  </div>

                  <p className="text-brand-brown/80 italic leading-relaxed flex-grow" data-id="element-365">
                    "{testimonial.quote}"
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}